/** The minimal shape this constraint reads: only `isCreation` drives whether the secret is mandatory. */
type ClientSecretRequirementShape = {
	readonly isCreation: boolean;
};

/**
 * Generic over the minimal shape it reads, not over `IdentityProviderFormData` itself, so the
 * FormData never has to import its own constraint back (`guides/forms.md` §1.1). The server never
 * re-serves the secret (SEC-12): its absence on an edit means "keep the one already registered," so
 * it is only mandatory the first time a configuration is created.
 */
function isClientSecretRequired<T extends ClientSecretRequirementShape>(value: string, formData: T): boolean {
	if (!formData.isCreation) {
		return true;
	}

	return value !== '';
}

export default isClientSecretRequired;
